"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.interceptorAfterReceive = void 0;
const isPlainObject_1 = __importDefault(require("lodash/isPlainObject"));
const ApiError_1 = require("../../../modules/base/errors/ApiError");
const ErrorWithRedirect_1 = require("../../../modules/base/errors/ErrorWithRedirect");
const constants_1 = require("../constants");
const get_blob_filename_1 = require("../helpers/get-blob-filename");
const interceptorAfterReceive = (response) => {
    if (response.config.responseType === 'blob' && response.status === 200) {
        const newResponse = {
            xhr: response.request,
            status: response.status === 200,
            statusCode: response.status,
            data: {
                filename: (0, get_blob_filename_1.getBlobFilename)(response),
                blob: response.data
            }
        };
        return newResponse;
    }
    if (!(0, isPlainObject_1.default)(response.data)) {
        return Promise.reject(new ApiError_1.ApiError(constants_1.ERROR_MESSAGE_DEFAULT, response.data.statusCode));
    }
    if (!response.data.status && 'error' in response.data) {
        return Promise.reject(new ApiError_1.ApiError(response.data.error, response.data.statusCode, response.data.exception));
    }
    if ('redirectUrl' in response.data) {
        return Promise.reject(new ErrorWithRedirect_1.ErrorWithRedirect(response.data.redirectUrl));
    }
    const newResponse = {
        xhr: response.request,
        status: response.data.status,
        statusCode: response.data.statusCode,
    };
    if ('data' in response.data) {
        newResponse.data = response.data.data;
    }
    if ('formErrors' in response.data) {
        newResponse.formErrors = response.data.formErrors;
    }
    if ('isNeedSmsVerify' in response.data) {
        newResponse.isNeedSmsVerify = response.data.isNeedSmsVerify;
    }
    if ('itemsWithErrors' in response.data) {
        newResponse.itemsWithErrors = response.data.itemsWithErrors;
    }
    return newResponse;
};
exports.interceptorAfterReceive = interceptorAfterReceive;
